import { useSetFilter } from '../../filter';
import { CampaignFilterKey } from '../domain/campaignFilterModel';

export const useSetCampaignFilter = () => {
  return useSetFilter(CampaignFilterKey, 'campaignFilter', true);
};
